import { SpeciesListNodeFields, TopSpeciesNearLocationNodeFields } from '../../generated/graphql';
import { TopSpeciesLinkCard } from '../Cards/TopSpeciesLinkCard/TopSpeciesLinkCard';

export const NearbyTopSpeciesCards = ({
  speciesList,
  visibleItems,
}: {
  speciesList: TopSpeciesNearLocationNodeFields[] | SpeciesListNodeFields[];
  visibleItems: number;
}) => {
  return (
    <div className="mt-2 flex flex-col">
      {speciesList.map(({ image, _id, displayName }, index) => {
        const imageUrl = image.url;
        const imageWidth = image.width;
        const imageHeight = image.height;

        return (
          <TopSpeciesLinkCard
            key={`species-${_id}`}
            speciesId={_id}
            name={displayName}
            className={`w-full ${index >= visibleItems ? 'hidden' : ''}`}
            imageUrl={imageUrl}
            imageWidth={imageWidth}
            imageHeight={imageHeight}
            clickEventPosition={index}
            clickEventSource="NearbyTopSpecies"
          />
        );
      })}
    </div>
  );
};
